import React, { createContext, PropsWithChildren, useContext, useState } from 'react';

type TabsContextType = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

type TabsProps = {
  className?: string;
  defaultActiveTab?: number | string;
};

const TabsContext = createContext<TabsContextType | undefined>(undefined);

export const Tabs: React.FC<PropsWithChildren<TabsProps>> = ({ children, className, defaultActiveTab }) => {
  const [activeTab, setActiveTab] = useState<string>(defaultActiveTab ? defaultActiveTab.toString() : '0');

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div className={className}>{children}</div>
    </TabsContext.Provider>
  );
};

export const useTabs = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('useTabs must be used within a CategoryTabs provider');
  }
  return context;
};
